import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=769bbdb5&scoped=true"
import script from "./sales.vue?vue&type=script&lang=js"
export * from "./sales.vue?vue&type=script&lang=js"
import style0 from "./sales.vue?vue&type=style&index=0&id=769bbdb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769bbdb5",
  null
  
)

export default component.exports